(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const revealSelector = [
    '.ys-page .page-hero > *',
    '.ys-page .content-band > *',
    '.ys-page .cta-band > *',
    '.ys-page .image-banner > *',
    '.ys-page article',
    '.yinshine-home-why__intro',
    '.yinshine-home-why__card',
    '.yz-hero__copy',
    '.yz-hero__media',
    '.yz-collection-card',
    '.yz-capability-grid article',
    '.yz-cta',
    '.yinshine-video-showcase__intro',
    '.yinshine-video-showcase__card',
    '.product-card-wrapper .card',
    '.collection-card-wrapper .card',
  ].join(',');

  const tiltSelector = [
    '.ys-page article',
    '.yinshine-home-why__card',
    '.yz-collection-card',
    '.yz-capability-grid article',
    '.yinshine-video-showcase__card',
    '.product-card-wrapper .card',
    '.collection-card-wrapper .card',
  ].join(',');

  const markRevealTargets = (root = document) => {
    if (reducedMotion || !('IntersectionObserver' in window)) return;

    const targets = Array.from(root.querySelectorAll(revealSelector)).filter((element) => {
      return !element.dataset.ysRevealReady && element.offsetParent !== null;
    });

    targets.forEach((element, index) => {
      element.dataset.ysRevealReady = 'true';
      element.classList.add('ys-premium-reveal');
      element.style.setProperty('--ys-reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);

      const rect = element.getBoundingClientRect();
      const isAlreadyInView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;

      if (isAlreadyInView) {
        element.classList.add('is-visible');
        return;
      }

      revealObserver.observe(element);
      window.setTimeout(() => {
        element.classList.add('is-visible');
      }, 1400 + Math.min(index % 6, 5) * 55);
    });
  };

  const markTiltTargets = (root = document) => {
    if (reducedMotion || !finePointer) return;

    root.querySelectorAll(tiltSelector).forEach((element) => {
      if (element.dataset.ysTiltReady) return;
      element.dataset.ysTiltReady = 'true';
      element.classList.add('ys-premium-tilt');

      element.addEventListener('pointermove', (event) => {
        const rect = element.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;

        element.style.setProperty('--ys-tilt-x', `${(-y * 2.2).toFixed(2)}deg`);
        element.style.setProperty('--ys-tilt-y', `${(x * 2.2).toFixed(2)}deg`);
      });

      element.addEventListener('pointerleave', () => {
        element.style.setProperty('--ys-tilt-x', '0deg');
        element.style.setProperty('--ys-tilt-y', '0deg');
      });
    });
  };

  const revealObserver = reducedMotion || !('IntersectionObserver' in window)
    ? null
    : new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  const init = (root = document) => {
    markRevealTargets(root);
    markTiltTargets(root);
  };

  const ready = () => {
    init();

    const main = document.querySelector('main#MainContent') || document.body;
    if (!('MutationObserver' in window) || !main) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          init(node);
        });
      });
    });

    observer.observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
